import { authenticatedPatch } from '../../../../../../api/request';

export default async function updateEducation(idDoctorUser, experienceBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando su información de educación.');
    const url = `/doctor-profile-management/education/${idDoctorUser}`;
    return await authenticatedPatch(url, onFail, experienceBody);
}
